import { render, staticRenderFns } from "./AGCSelectGroup.vue?vue&type=template&id=6b838203&"
import script from "./AGCSelectGroup.vue?vue&type=script&lang=js&"
export * from "./AGCSelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports